import * as React from "react";
import { IoTrashBinOutline } from "react-icons/io5";
import { Button, Modal } from "components";
import { useCurrentCase } from "duck";
import { useRemoveMedications } from "./duck";

interface RemoveProps {
  selectedKeys: (string | number)[];
  onSuccess(): void;
}

const Remove: React.FC<RemoveProps> = ({ selectedKeys, onSuccess }) => {
  const meds = useCurrentCase(
    ({ data }) => data.client.patient.currentMedications
  );

  const medsToDelete = selectedKeys
    .map(key => {
      return typeof key === "number"
        ? meds.find(med => med._id === key)
        : meds.find(med => med.fakeId === key);
    })
    .map(med => med?.medication)
    .filter(Boolean) as string[];

  const onConfirm = useRemoveMedications(selectedKeys, onSuccess);

  return (
    <Modal.Confirm
      onConfirm={onConfirm}
      confirmText="Remove"
      title={
        selectedKeys.length > 1 ? "Remove Medications" : "Remove Medication"
      }
      successMessage={
        selectedKeys.length > 1
          ? `Medications ${medsToDelete.join(", ")} are deleted successfully.`
          : `Medication ${medsToDelete[0]} is deleted successfully.`
      }
      body="Are you sure you want to remove? You can’t undo this action afterwards."
    >
      <Button
        colorScheme="red"
        leftIcon={<IoTrashBinOutline />}
        disabled={selectedKeys.length === 0}
      >
        Remove
      </Button>
    </Modal.Confirm>
  );
};

export default Remove;
